import * as Api from '../../../api/Api';
import { useState } from 'react';
import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { Unauthorized } from '../../Global/unauthorized';
import TableFromServer from "../../../Components/Table/TableFromServer";
import { PageTitle } from '../../../../_metronic/layout/core';
import { useGetToken } from '../../../Hooks/CustomHooks';
import ActualizarContrato from './ActualizarContrato';
import makeAnimated from 'react-select/animated';
import Select from 'react-select';
import * as Utilities from '../../../Components/Utils/Utils';
import Modal from 'react-bootstrap/Modal';
import AgTable from '../../../Components/Table/AgTable';

export default function Contratos({ title }) {
    const [abirGuardarContrato, setAbirGuardarContrato] = useState(false);
    const [guardadoExitoso, setGuardadoExitoso] = useState(false);

    const header = [
        {
            headerName: 'Código',
            field: 'codContrato',
            type: 'rightAligned',
        },
        {
            headerName: 'Denominación',
            field: 'denCont',
        },
        {
            headerName: 'Fecha Ini Op',
            field: 'fechaInicioOperaciones',
        },
        {
            headerName: 'Fecha Fin Op',
            field: 'fechaFinOperaciones',
        },
        {
            headerName: 'Actualizar Fecha',
            cellRenderer: (props) => (
                <div className='text-center'>
                    <button className="btn btn-light btn-active-light-primary btn-sm" onClick={
                        function () {
                            setCurrentContrato(props.data);
                            setAbirGuardarContrato(true);
                        }
                    } >
                        <i className="fi-rr-edit"></i>
                    </button>
                </div>
            )
        },
    ]

    const animatedComponents = makeAnimated();

    const lsUnidadEconomica = JSON.parse(sessionStorage.getItem("ActualizarContrato_UE"));

    const [unidadEconomica, setUnidadEconomica] = useState(
        lsUnidadEconomica != null ? lsUnidadEconomica : Utilities.getListUnidadesEconomicas().list[0]
    );

    let unidadesEconomicasList = Utilities.getListUnidadesEconomicas();

    const getOptionValue = idDefault => {
        return unidadesEconomicasList.list.filter(obj => obj.value === idDefault)
    }

    const onChangeGraphType = (inputValue) => {
        sessionStorage.setItem("ActualizarContrato_UE", JSON.stringify(inputValue));
        setUnidadEconomica(inputValue);
    }

    const [currentContrato, setCurrentContrato] = useState(null);

    const tokenn = useGetToken();

    function onAfterGuardar(action) {
        setAbirGuardarContrato(false);
        if (action === true) setGuardadoExitoso(true);
    }
    function guardadoExistosoModal() {
        setGuardadoExitoso(false)
        window.location.reload(false);
    }

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.ACTUALIZAR_CONTRATOS]} >
                <PageTitle>{title}</PageTitle>

                <div className="card my-5">
                    <div className="card-header border-0 pt-6">
                        <div className="d-flex align-items-center mb-3">
                            <div className="p-2" style={{ minWidth: "200px" }}>
                                <div className="fw-bold fs-7 text-gray-600 mb-1">Mall:</div>
                                <Select
                                    classNamePrefix='filter'
                                    components={animatedComponents}
                                    defaultValue={lsUnidadEconomica != null ? lsUnidadEconomica : getOptionValue(unidadesEconomicasList.defaultId)}
                                    isMulti={false}
                                    closeMenuOnSelect={true}
                                    options={unidadesEconomicasList.list}
                                    onChange={(onChangeGraphType)}
                                />
                            </div>
                        </div>
                    </div>

                    {
                        abirGuardarContrato &&
                        <>
                            <ActualizarContrato currentContrato={currentContrato} setSmShow={onAfterGuardar}></ActualizarContrato>
                        </>
                    }

                    <div className="card-body tab-content pt-0">
                        <AgTable
                            idContent={"Contratos " + unidadEconomica.value}
                            apiService={Api.ListaContratos}
                            setAuxData={null}
                            header={header}
                            titleExcel={"Contratos - " + unidadEconomica.label}
                            conditions={true}
                            args={{ unidadEconomicaId: unidadEconomica.value, token: tokenn }}
                            hideFilter={false}
                            paginationPageSize={8}
                            rowHeight={40}
                            useFlex={false}
                        />
                    </div>
                </div>

                <Modal
                    size="sm"
                    show={guardadoExitoso}
                    onHide={() => setGuardadoExitoso(false)}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header>
                        <Modal.Title id="example-modal-sizes-title-sm" style={{ margin: 'auto' }}>
                            Guardado Exitoso
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Footer style={{ margin: 'auto' }}>
                        <button type="button" className="btn btn-primary" onClick={guardadoExistosoModal}>
                            Aceptar
                        </button>
                    </Modal.Footer>
                </Modal>



            </PermissionsGate>
        </>
    )
}